import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { mrfInterviewAction as actions, notificationActions } from '../actions';
import { mrfInterviewService } from '../services';

/* Get Assigned Interview Sagas */ 
function* handleAssignedInterviewRequest() {
  const action = yield take(actions.assignedInterviewRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfInterviewService.assignedInterview, dataParams);

    if (res.isError) {
      yield put(actions.assignedInterviewError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.assignedInterviewSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.assignedInterviewError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Get Assigned Interview Sagas */
function* handleGetAssignedInterviewRequest() {
  const action = yield take(actions.getAssignedInterviewRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfInterviewService.getAssignedInterview, dataParams);

    if (res.isError) {
      yield put(actions.getAssignedInterviewError(res));

    } else {
      yield put(actions.getAssignedInterviewSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAssignedInterviewError());
  }
}

/* Get Interviewr Sagas */
function* handleGetInterviewrRequest() {
  const action = yield take(actions.getInterviewrRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfInterviewService.getInterviewr, dataParams);

    if (res.isError) {
      yield put(actions.getInterviewrError(res));

    } else {
      yield put(actions.getInterviewrSuccess(res));
    }

  } catch (error) {
    yield put(actions.getInterviewrError());
  }
}

/* Get Question By Interview Sagas */
function* handleGetQuestionByInterviewStageRequest() {
  const action = yield take(actions.getQuestionByInterviewStageRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfInterviewService.getQuestionByInterviewStage, dataParams);

    if (res.isError) {
      yield put(actions.getQuestionByInterviewStageError(res));

    } else {
      yield put(actions.getQuestionByInterviewStageSuccess(res));
    }

  } catch (error) {
    yield put(actions.getQuestionByInterviewStageError());
  }
}

/* Fill Feedback Form */
function* handleFillFeedbackFormRequest() {
  const action = yield take(actions.fillFeedbackFormRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfInterviewService.fillFeedbackForm, dataParams);

    if (res.isError) {
      yield put(actions.fillFeedbackFormError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.fillFeedbackFormSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      
    }
    
  } catch (error) {
    yield put(actions.fillFeedbackFormError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Get Interview Details By Id */
function* handleGetInterviewDetailsByIdRequest() {
  const action = yield take(actions.getInterviewDetailsByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfInterviewService.getInterviewDetailsById, dataParams);

    if (res.isError) {
      yield put(actions.getInterviewDetailsByIdError(res));

    } else {
      yield put(actions.getInterviewDetailsByIdSuccess(res));
    }

  } catch (error) {
    yield put(actions.getInterviewDetailsByIdError());
  }
}


/* -----------Watchers------------- */
function* handleAssignedInterviewWatcher() {
  yield takeEvery(
    actions.assignedInterviewRequest,
    handleAssignedInterviewRequest,
  );
}
function* handleGetAssignedInterviewWatcher() {
  yield takeEvery(
    actions.getAssignedInterviewRequest,
    handleGetAssignedInterviewRequest,
  );
}
function* handleGetInterviewrWatcher() {
  yield takeEvery(
    actions.getInterviewrRequest,
    handleGetInterviewrRequest,
  );
}
function* handleGetQuestionByInterviewStageWatcher() {
  yield takeEvery(
    actions.getQuestionByInterviewStageRequest,
    handleGetQuestionByInterviewStageRequest,
  );
}

function* handleFillFeedbackFormWatcher() {
  yield takeEvery(
    actions.fillFeedbackFormRequest,
    handleFillFeedbackFormRequest,
  );
}

function* handleGetInterviewDetailsByIdWatcher() {
  yield takeEvery(
    actions.getInterviewDetailsByIdRequest,
    handleGetInterviewDetailsByIdRequest,
  );
}

function* rootMrfInterviewSaga() {
  yield all([
    handleAssignedInterviewRequest(),
    handleAssignedInterviewWatcher(),

    handleGetAssignedInterviewRequest(),
    handleGetAssignedInterviewWatcher(),

    handleGetInterviewrRequest(),
    handleGetInterviewrWatcher(),

    handleGetQuestionByInterviewStageRequest(),
    handleGetQuestionByInterviewStageWatcher(),

    handleFillFeedbackFormRequest(),
    handleFillFeedbackFormWatcher(),

    handleGetInterviewDetailsByIdRequest(),
    handleGetInterviewDetailsByIdWatcher(),
  ]);
}

export default rootMrfInterviewSaga;
